module.exports = __webpack_public_path__ + "static/media/vuelta_reverso.e229013c.jpg";